
import { mapActions } from 'vuex';
import UILegalDisclaimer from '@/components/ui/organism/UILegalDisclaimer';

export default {
  name: 'UILegalDisclaimerModal',
  components: {
    UILegalDisclaimer,
  },
  methods: {
    ...mapActions('modals', ['toggleLegalDisclaimerModal']),
  },
};
